import {MerchantCatalog} from '../models/catalog.model';
import { Restaurant, RestaurantCategory } from '../models/restaurant.model';

export const dataToMerchantCatalogs = (data: any[]): MerchantCatalog[] => {
  return data.map(catalog => dataToMerchantCatalog(catalog));
};
export const dataToMerchantCatalog = (data: any): MerchantCatalog => new MerchantCatalog(
  data.location_ids,
  data.name
);

export const organizeCategories = (categories: RestaurantCategory[], restaurant: Restaurant): RestaurantCategory[] => {
  const categoryMap = new Map<string, RestaurantCategory>();

  categories.forEach(category => {
    if (categoryMap.has(category.id)) {
      const existingCategory = categoryMap.get(category.id);
      existingCategory.name = category.name || existingCategory.name;
      existingCategory.parentCategoryId = category.parentCategoryId || existingCategory.parentCategoryId;
    } else {
      category.subCategories = [];
      categoryMap.set(category.id, category);
    }
  });

  const topLevelCategories: RestaurantCategory[] = [];
  const allCategories = Array.from(categoryMap.values());

  allCategories.forEach(category => {
    if (category.parentCategoryId && restaurant.enableParentSubCategories) {
      const parentCategory = categoryMap.get(category.parentCategoryId);
      if (parentCategory) {
        const alreadyExists = parentCategory.subCategories.some(subCat => subCat.id === category.id);
        if (!alreadyExists) {
          parentCategory.subCategories.push(category);
        }
      } else {
        topLevelCategories.push(category);
      }
    } else {
      topLevelCategories.push(category);
    }
  });

  const removeDuplicates = (categories: RestaurantCategory[]) => {
    categories.forEach(category => {
      const uniqueSubCategories = new Map<string, RestaurantCategory>();
      category.subCategories.forEach(subCategory => {
        uniqueSubCategories.set(subCategory.id, subCategory);
      });
      category.subCategories = Array.from(uniqueSubCategories.values());
      removeDuplicates(category.subCategories);
    });
  };

  removeDuplicates(topLevelCategories);

  return topLevelCategories;
};



